module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2r6n9n-0059027588771f70f78a5effaf14927e.svg";